import { Link, Typography, pxToRem, theme } from '@pocketlaw/tetris';
import styled, { css } from 'styled-components';
export const StyledLink = styled(Link) `
  cursor: pointer;
`;
export const StyledTypography = styled(Typography) `
  margin-top: ${theme.spacing.lg};
`;
const getDraggingStyles = (props) => {
    const { $dragging, $draggingOver } = props;
    if ($draggingOver) {
        return css `
      outline: solid ${pxToRem(2)} ${theme.swatches.blue[500]};
      border: solid ${pxToRem(1)} ${theme.swatches.blue[500]};
      background-color: ${theme.swatches.blue[50]};
    `;
    }
    if ($dragging) {
        return css `
      outline: solid ${pxToRem(2)} transparent;
      border: dashed ${pxToRem(1)} ${theme.swatches.blue[200]};
      background-color: ${theme.semantic.surface.sunken};
    `;
    }
    return css `
    outline: solid ${pxToRem(2)} transparent;
    border: dashed ${pxToRem(1)} ${theme.semantic.border.default};
    background-color: ${theme.semantic.surface.sunken};
  `;
};
export const DropContainer = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  outline-offset: ${pxToRem(-2)};
  border-radius: ${theme.borderRadius.md};
  transition: all 175ms ease-in-out;
  ${(props) => getDraggingStyles(props)};
  height: ${(props) => (props.$small ? pxToRem(160) : pxToRem(320))};
`;
export const DropContainerContent = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  pointer-events: ${(props) => (props.$dragging ? 'none' : 'all')};
`;
